<template>
<div>
      <the-nav-bar :title="$t('global.tigaRatesInfo.title')" />
      <div class="detail-wrapper">
       <ul>
          <div class="text-title">{{$t('global.tigaRatesInfo.landunTextTitle')}}</div>
          <li>{{$t('global.tigaRatesInfo.markerText')}}<span class="rate-text">{{rates.landunAdRate}}%</span></li>
          <li>{{$t('global.tigaRatesInfo.takerText')}}<span class="rate-text">{{rates.landunResponseRate}}%</span></li>
       </ul>
        <ul>
          <div class="text-title">{{$t('global.tigaRatesInfo.commonTextTitle')}}</div>
          <li>{{$t('global.tigaRatesInfo.markerTextOri')}}<span class="rate-text">{{rates.commonAdRate}}%</span></li>
          <li>{{$t('global.tigaRatesInfo.takerTextOri')}}<span class="rate-text">{{rates.commonResponseRate}}%</span></li>
       </ul>


       <div class="special-div" v-if="this.rates.special.length">
        <hr/>
        <div style="font-weight:bold; color:red; padding-bottom: 15px;">特别调整：</div>
        <div class="special-asset-fee"
          v-for="asset in this.rates.special"
          :key="asset.key"
        >
          <span style="font-weight:bold;">{{asset.symbol}}:</span>
          <ul>
              <div class="text-title">{{$t('global.tigaRatesInfo.landunTextTitle')}}</div>
              <li>{{$t('global.tigaRatesInfo.markerTextOri')}}<span class="rate-text">{{asset.landun_advertisement_rate}}%</span></li>
              <li>{{$t('global.tigaRatesInfo.takerTextOri')}}<span class="rate-text">{{asset.landun_response_rate}}%</span></li>
          </ul>
            <ul>
              <div class="text-title">{{$t('global.tigaRatesInfo.commonTextTitle')}}</div>
              <li>{{$t('global.tigaRatesInfo.markerTextOri')}}<span class="rate-text">{{asset.advertisement_rate}}%</span></li>
              <li>{{$t('global.tigaRatesInfo.takerTextOri')}}<span class="rate-text">{{asset.response_rate}}%</span></li>
          </ul>

         <hr>
        </div>

       </div>



      </div>
</div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import getTigaRates from '@/api/get-tiga-rates.js';
import { mapState } from 'vuex';

export default {
  name: 'notice-bar',
  components: {
    TheNavBar,
  },
  data() {
    return {
      rates:{
        special:[],
      },
    };
  },
  computed: {
    ...mapState({
      navLang: state => state.navLang,
      tigaRates: state=> state.tigaRates,
    }),
  },
  mounted() {
    if(!this.tigaRates){
      getTigaRates()
        .then(data=>{
          this.rates = data.data;
          this.$store.commit('setTigaHome', {
            tigaRates: this.rates,
          });
        });
    }else{
      this.rates = this.tigaRates;
    }
  },
  methods:{

  },
};

</script>

<style lang="stylus" scoped>
.detail-wrapper
  padding: 0 8.88vw;

.text-title
  font-weight: bold;
  margin-bottom: 3vw;

.rate-text 
  font-weight: bold;
  margin-left: 1.18vw;
>>> ul
  padding-inline-start: 3vw;
>>> li 
  list-style: initial;
  margin-bottom: 2.18vw;

.special-div 
  padding-top: 3vw;
  padding-bottom: 5vw;


</style>
